
import SsrCarousel from 'vue-ssr-carousel'
export default {
  name:'Recommend',
  components: { SsrCarousel },
  data() {
    return {
      slidesToShow: 3,
    };
  },
  mounted() {
    // Get the number of slotted children.
    const childrenCount = this.$slots.default ? this.$slots.default.length : 0;
    // If the number of children is less than 3, set slidesToShow to that number.
    console.log('Children count:', childrenCount);
    if (childrenCount < 3) {
      this.slidesToShow = childrenCount;
    }
  },

}
